import { call, put, takeLatest } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import swal from 'sweetalert';
import api from 'services/api';

import { Creators as ProductsTypesActions, Types as ProductsTypesTypes } from 'store/ducks/productsTypes';

function* getProductTypeRequest(action) {
  try {
    const { id } = action.payload;
    const url = `store/v2/product_types/${id}`;
    const response = yield call(api.get, url);

    yield put(ProductsTypesActions.getProductTypeSuccess(response.data));
  } catch (error) {
    yield put(ProductsTypesActions.getProductTypeFailure());
  }
}

function* getProductsTypesRequest(action) {
  try {
    const { page } = action.payload;
    const url = `store/v2/product_types?page=${page}&per=25`;
    const response = yield call(api.get, url);

    yield put(ProductsTypesActions.getProductsTypesSuccess(response.data));
  } catch (error) {
    yield put(ProductsTypesActions.getProductsTypesFailure());
  }
}

function* updateProductsTypeRequest(action) {
  try {
    const { id, data } = action.payload;
    const url = `store/v2/product_types/${id}`;
    yield call(api.put, url, data);

    yield put(push('/points/products-types'));
    yield call(swal, 'Atualizado', 'Tipo de Produto atualizado com sucesso.', 'success');
    yield put(ProductsTypesActions.updateProductsTypeSuccess());
  } catch (error) {
    yield call(swal, 'Falha ao atualizar', 'Não foi possível atualizar o tipo de produto.', 'error');
    yield put(ProductsTypesActions.updateProductsTypeFailure());
  }
}

export default function* sagaProductsTypes() {
  yield takeLatest(ProductsTypesTypes.GET_REQUEST, getProductTypeRequest);
  yield takeLatest(ProductsTypesTypes.GET_LIST_REQUEST, getProductsTypesRequest);
  yield takeLatest(ProductsTypesTypes.UPDATE_REQUEST, updateProductsTypeRequest);
}
